import { render, staticRenderFns } from "./mealSort.vue?vue&type=template&id=7c485ef1&scoped=true&"
import script from "./mealSort.vue?vue&type=script&lang=js&"
export * from "./mealSort.vue?vue&type=script&lang=js&"
import style0 from "./mealSort.vue?vue&type=style&index=0&id=7c485ef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c485ef1",
  null
  
)

export default component.exports